import styles from './BarGroup.module.scss'

const BarGroupTooltip = ({zeroPosition, choosenBar, xKey, formatValue}) => {
    return (
        <div className={styles['tooltip']} style={{top: zeroPosition + (choosenBar.value < 0 ? choosenBar.height : -choosenBar.height), left: choosenBar.x - 25}}>
          <p>{choosenBar.groupData[xKey]}</p>
          {choosenBar.group.map(({color, value}) => (
            <p key={`${color}-${value}`} style={{color}}>
              {value && formatValue(value)}
          </p>))}
        </div>
    )
}

export default BarGroupTooltip